import { css } from 'emotion';

import { colors, fonts } from '../styles';

/*
 * The inline-table is being used to keep the span width as an integer
 * because its default value is a float that breaks the transform on
 * the LinearProgress component since this property considers the decimal
 * numbers while the width doesn't.
 */

export const progressBar = css`
  width: 100%;
  display: flex;
  align-items: center;
  color: ${colors.gray.dark};
  font-size: ${fonts.size.smallest};

  span {
    margin-left: 10px;
    display: inline-table;
  }
`;
